const mutations = {
    SETFILESTATE(state,payload) {
        state.fileState = Object.assign(state.fileState,payload);
    },
    SETEFFECTSIMAGE(state,payload) {

        if(!state.effectImageObject)state.effectImageObject = payload;
    },
    SET_ASSET_ANIMATIONS(state,payload){ state.assetsAniamtions.push(payload)} 
}

export default mutations;


// WEBPACK FOOTER //
// ./src/store/assets/mutations.js